// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__UEQWq","alertIcon":"ConfirmModal_alertIcon__zJ9mg"};